export const MINOR_IMPERFECTION = "totalImperfectionsCount";

export const PERFECT_CONDITION_TEXTS = {
    [MINOR_IMPERFECTION]: "No imperfections"
};

export const PERFECT_CONDITION_DESCRIPTION = {
    [MINOR_IMPERFECTION]: "This car is in perfect condition"
};
